import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AddressDetailPageModule } from '@modals/address/address-detail/address-detail.module';
import { CreateAddressPageModule } from '@modals/address/create-address/create-address.module';
import { ForgotPasswordPageModule } from '@modals/auth/login/forgot-password/forgot-password.module';
import { UpdatePasswordPageModule } from '@modals/auth/login/update-password/update-password.module';
import { RegisterCountryPageModule } from '@modals/auth/register-form/register-country/register-country.module';
import { RegisterPageModule } from '@modals/auth/register-form/register/register.module';
import { CompliancePageModule } from '@modals/docs/compliance/compliance.module';
import { ConsentPageModule } from '@modals/docs/consent/consent.module';
import { FarmacoPageModule } from '@modals/docs/farmaco/farmaco.module';
import { TermsPageModule } from '@modals/docs/terms/terms.module';
import { ReleasesPageModule } from '@modals/features/releases/releases.module';
import { DeleteAccountPageModule } from '@modals/profile/delete-account/delete-account.module';
import { MenuProfilePageModule } from '@modals/profile/menu-profile/menu-profile.module';
import { UpdateProfilePageModule } from '@modals/profile/update-profile/update-profile.module';
import { GatherDetailsPageModule } from '@modals/request/gather-details/gather-details.module';
import { KitDetailPageModule } from '@modals/request/kit-detail/kit-detail.module';
import { ResumeSamplePageModule } from '@modals/request/resume-sample/resume-sample.module';

import { ComponentsModule } from '../components/components.module';
import { ConfirmationPageModule } from './docs/confirmation/confirmation/confirmation.module';

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    ComponentsModule,
    IonicModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ForgotPasswordPageModule,
    UpdatePasswordPageModule,
    RegisterPageModule,
    GatherDetailsPageModule,
    KitDetailPageModule,
    RegisterCountryPageModule,
    CreateAddressPageModule,
    AddressDetailPageModule,
    MenuProfilePageModule,
    ResumeSamplePageModule,
    UpdateProfilePageModule,
    DeleteAccountPageModule,
    TermsPageModule,
    ConsentPageModule,
    FarmacoPageModule,
    CompliancePageModule,
    ReleasesPageModule,
    ConfirmationPageModule
  ]
})
export class ModalsModule {}
